export const BankAuthorizations = {
  Authorize: 'Potvrdit platby',
  BatchId: 'Id hromadné platby',
  AuthorizationState: 'Stav autorizace',
  PaymentsCount: 'Počet plateb',
  TotalAmount: 'Celková částka',
};
